import { useBackfillCompletion } from '../../BackfillContext'

import { EmptyStateExplainerCard } from '../../components/EmptyStates'

import type { JSX } from 'react'

type NoBackfilledCommentsCardProps = {
  channelId: string | null
}

/**
 * Explainer shown inside the listening empty state right after a newly
 * connected channel's first backfill finishes with no comments — reassures the
 * user that only the last 30 days of comments are imported on connect. Gated on
 * that first sync, so once the channel has been synced it never shows again,
 * leaving a plain empty state. Single-channel only.
 */
export function NoBackfilledCommentsCard({
  channelId,
}: NoBackfilledCommentsCardProps): JSX.Element | null {
  const { hasChannelCompleted, hasChannelFirstSync } = useBackfillCompletion()

  if (
    !channelId ||
    !hasChannelCompleted(channelId) ||
    !hasChannelFirstSync(channelId)
  ) {
    return null
  }

  return (
    <EmptyStateExplainerCard
      heading="Can't see all your past comments? Don't worry!"
      body="When you connect a new channel, we import existing comments from your most recent posts - up to 30 days back."
    />
  )
}
